module.exports = __webpack_public_path__ + "static/media/padmasana.e8143ea6.svg";